import React from 'react';
import ListPanel from '@/components/ListPanel';
import { isVoid } from '@/utils/common';
import RecordList from './RecordList';

export default function ExecutiveRecord() {
  return (
    <ListPanel header='操作记录' tip='包含了脚本执行、组件执行和流程执行的记录'>
      <RecordList />
    </ListPanel>
  );
}

export const RESULT_STATUS = {
  READY: 'READY',
  PROCESSING: 'PROCESSING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

// 结果字典 处理魔鬼状态 '0' 0 ''等
export function getExecResultCodeStatus(code) {
  if (isVoid(code)) {
    return RESULT_STATUS.READY;
  }
  if (`${code}` === '0') {
    return RESULT_STATUS.PROCESSING;
  }
  if (Number(code) === 1) {
    return RESULT_STATUS.ERROR;
  }
  if (Number(code) === 2) {
    return RESULT_STATUS.SUCCESS;
  }
}
